import React from 'react';
import { Navigate } from 'react-router-dom';

// Lazy load components
const DonorLogin = React.lazy(() => import('../pages/DonorLogin/DonorLogin'));
const DonorSignUp = React.lazy(() => import('../pages/DonorLogin/DonorSignUp'));
const DonorDashboard = React.lazy(() => import('../pages/DonorLogin/DonorDashboard'));

export const getDonorLoginRoutes = (donorLoggedIn) => [
  {
    path: '/donors/login',
    element: <DonorLogin />
  },
  {
    path: '/donors/signup',
    element: <DonorSignUp />
  },
  {
    path: '/donors/dashboard',
    element: donorLoggedIn
      ? <DonorDashboard />
      : <Navigate to="/donors/login" replace />
  }
];

